import { getStatusForId as getStatus } from '@ms/yammer-data-support';

import type { ImageFile, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';
import { getLegacyHost } from '../session/selectors';
/**
 * @deprecated PERFORMANCE This returns an entity object and will force re-renders whenever an API call etc. updates the entity.
 * This should be replaced with a `getImageFileField` selector.
 */
export const findById: FindById<'imageFiles'> = createFindById('imageFiles');
/**
 * @deprecated PERFORMANCE This returns an entity object and will force re-renders whenever an API call etc. updates the entity.
 * This should be replaced with a `getImageFileFieldThrows` selector.
 */
export const findByIdThrows: FindByIdThrows<'imageFiles'> = createFindByIdThrows('imageFiles');
type GetUrlFromLegacyHost = (legacyHost: string, databaseId: ImageFile['databaseId']) => string;
export const getUrlFromLegacyHost: GetUrlFromLegacyHost = (legacyHost, id) => `${legacyHost}/uploaded_files/${id}`;
type GetUrl = (state: YammerState, id: ImageFile['id']) => string;
export const getUrl: GetUrl = (state, id) => {
  const { databaseId } = findByIdThrows(state, id);

  return getUrlFromLegacyHost(getLegacyHost(state), databaseId);
};
type ImageVisibilitySelector = (state: YammerState, id: ImageFile['id']) => boolean;
export const isDeleted: ImageVisibilitySelector = (state, id) => {
  const { state: imageFileState } = findByIdThrows(state, id);

  return imageFileState === 'DELETED';
};
export const isInaccessible: ImageVisibilitySelector = (state, id) => {
  const { state: imageFileState } = findByIdThrows(state, id);

  return imageFileState === 'INACCESSIBLE';
};
export const isActive: ImageVisibilitySelector = (state, id) => {
  const { state: imageFileState } = findByIdThrows(state, id);

  return imageFileState === 'ACTIVE';
};
type ImageFileVisibilitySelector = (imageFile: ImageFile) => boolean;
export const isImageFileDeleted: ImageFileVisibilitySelector = (imageFile) => imageFile.state === 'DELETED';
export const isImageFileActive: ImageFileVisibilitySelector = (imageFile) => imageFile.state === 'ACTIVE';
export const isImageFileInaccessible: ImageFileVisibilitySelector = (imageFile) => imageFile.state === 'INACCESSIBLE';
type GetFulfilledImageFiles = (state: YammerState) => Record<string, ImageFile>;
/**
 * @deprecated PERFORMANCE This returns the entire object of fulfilled entity objects, which is a new object reference whenever
 * ANY entity in this reducer gets updated and forces unnecessary re-renders. Consumers should use more granular selectors.
 */
export const getFulfilledImageFiles: GetFulfilledImageFiles = (state) => state.imageFiles.fulfilled.byId;
type GetStatusForId = (state: YammerState, fileId: ImageFile['id']) => ReturnType<typeof getStatus>;
export const getStatusForId: GetStatusForId = (state, fileId) => getStatus(state.imageFiles, fileId);
